import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { createBrowserRouter, RouterProvider } from "react-router";

import { DeviceProvider } from "./device/DeviceProvider";
import { routes } from "./router";

// Server state lives in TanStack Query; client state is kept minimal (docs/09 "Web UI").
const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, refetchOnWindowFocus: false, staleTime: 5_000 },
  },
});

const router = createBrowserRouter(routes);

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <DeviceProvider>
        <RouterProvider router={router} />
      </DeviceProvider>
    </QueryClientProvider>
  );
}
